import React from "react";

const safeUseReveal = () => {
  try {
    // @ts-ignore
    if (typeof useReveal === "function") return useReveal();
  } catch (e) {}
  return null;
};

const safeHide = (direction) => {
  try {
    // @ts-ignore
    if (typeof hide === "function") return hide(direction);
  } catch (e) {}
  return {};
};

const CORE_VALUES = [
  {
    id: "01",
    title: "Integrity",
    desc: "Fostering a business environment built on trust, transparency, professionalism, compliance, and ethical business practices.",
  },
  {
    id: "02",
    title: "Sustainability",
    desc: "Supporting responsible business models, innovation, and internationally aligned trade and investment practices.",
  },
  {
    id: "03",
    title: "Cross-cultural Partnership",
    desc: "Building strong partnerships between Bangladeshi and Italian businesses through collaboration, intercultural dialogue, and shared expertise.",
  },
  {
    id: "04",
    title: "Accountability",
    desc: "Promoting transparency, measurable impact, sound governance, and value creation for members and stakeholders.",
  },
];

export const CoreValuesSection = () => {
  const ref = safeUseReveal();

  return (
    <section ref={ref} className="bg-[#F8F9FA] py-20 lg:py-28 font-sans">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">

        {/* Section Header */}
        <div className="max-w-3xl mx-auto text-center mb-16 md:mb-20">
          <h2
            data-r
            style={safeHide("up")}
            className="text-4xl md:text-5xl font-black text-[#0F1C35] leading-tight tracking-tight mb-4"
          >
            Our Core <span className="text-[#0F1C35]">Values</span>
          </h2>
        </div>

        {/* Values Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {CORE_VALUES.map((value) => (
            <div
              key={value.id}
              data-r
              style={safeHide("up")}
              className="group bg-white rounded-2xl border border-gray-100 p-8 hover:shadow-xl hover:border-gray-200 transition-all duration-300 flex flex-col h-full relative overflow-hidden"
            >
              {/* Subtle top border accent on hover */}
              <div className="absolute top-0 left-0 w-full h-1 bg-[#0077b6] transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left" />

              {/* Title */}
              <h3 className="text-xl font-bold text-[#0077b6] mb-4 group-hover:text-[#0077b6] transition-colors duration-300 min-h-[56px] flex items-center">
                {value.title}
              </h3>

              {/* Description */}
              <p className="text-gray-600 text-sm leading-relaxed flex-grow">
                {value.desc}
              </p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default CoreValuesSection;